import { Popup } from "../Popup/Popup";
import { IGifNichesPopup } from "@/common/buses/popups/popup-types";
import { onCloseGifNichesPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { NicheCard } from "@/components/search/NicheCard";
import { useSfw } from "@/common/hooks/useSfw";
import { Button } from "@/components/buttons/Button";
import { useNavigate } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { memo, useMemo } from "react";
import { metricsBus, EventSource } from "@/common/buses";

import "./GifNichesPopup.scss";

export const GifNichesPopup = memo(({ niches }: IGifNichesPopup) => {
  const navigate = useNavigate();
  const { sanitizeNiche } = useSfw();

  const safeNiches = useMemo(
    () => niches.map(n => sanitizeNiche(n)),
    [niches, sanitizeNiche]
  );

  const onNicheClick = (nicheId: string) => {
    metricsBus.emit("nichePreviewClicked", {
      nicheId,
      source: EventSource.GifCard,
      initiator: "gif",
    });

    navigate(routes.niche(nicheId));
    onCloseGifNichesPopup();
  };

  return (
    <Popup isOpen onClose={onCloseGifNichesPopup} title="Niches" popupClass="GifNichesPopup">
      <div className="GifNichesPopup-List">
        {safeNiches.map((niche) => (
          <div className="GifNichesPopup-Item" key={niche.id}>
            <NicheCard
              nicheImageUrl={niche.thumbnail}
              nicheName={niche.name}
              followers={niche.subscribers}
              id={niche.id}
              onClick={() => {}}
            />
            <Button
              variant="secondary"
              size="xs"
              onClick={() => onNicheClick(niche.id)}
            >
              Visit
            </Button>
          </div>
        ))}
      </div>
    </Popup>
  );
});
